module.exports = __webpack_public_path__ + "static/media/featured_listing_3.a033d14e.png";